import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

const POLICY_DATE = "October 19, 2026";
const POLICY_DATE_TIME = "2026-10-19";

function PolicyPage({
  eyebrow = "Legal",
  title,
  introduction,
  sections,
  showDate = true,
}) {
  return (
    <main className="privacy-page">
      <header className="privacy-page__hero">
        <p>{eyebrow}</p>
        <h1>{title}</h1>
        <div>
          <p>{introduction}</p>
          {showDate && (
            <p className="privacy-page__date">
              Last updated <time dateTime={POLICY_DATE_TIME}>{POLICY_DATE}</time>
            </p>
          )}
        </div>
      </header>

      <div className="privacy-page__layout">
        <aside>
          <nav aria-label={`${title} sections`}>
            <p>Contents</p>
            {sections.map((section) => (
              <a href={`#${section.id}`} key={section.id}>
                {section.shortTitle || section.title}
              </a>
            ))}
          </nav>
        </aside>

        <article className="privacy-page__content">
          {sections.map((section, index) => (
            <section
              id={section.id}
              aria-labelledby={`${section.id}-title`}
              key={section.id}
            >
              <span>{String(index + 1).padStart(2, "0")}</span>
              <h2 id={`${section.id}-title`}>{section.title}</h2>
              {section.content}
            </section>
          ))}
        </article>
      </div>
    </main>
  );
}

export function PolicyContact({ label = "Policy enquiries" }) {
  return (
    <div className="privacy-page__contact">
      <p>{label}</p>
      <a href={`mailto:${siteConfig.contact.email}`}>
        {siteConfig.contact.email}
      </a>
      <Link to="/contact">Contact Client Services</Link>
    </div>
  );
}

export default PolicyPage;
